module.exports = __webpack_public_path__ + "media/images/icons/outlined/hourglass-2bef755029ad435c364e1d738607634b.svg";